import { FormattedMessage } from 'react-intl';
import { useDateHistory } from '../hooks/useDateHistory';
import StatsPanelView from './StatsPanelView';

const loadingCards = Array.from({ length: 3 }, (_, slot) => `card-${String(slot)}`);
const loadingHeaders = Array.from({ length: 4 }, (_, slot) => `header-${String(slot)}`);
const loadingRows = Array.from({ length: 6 }, (_, slot) => `row-${String(slot)}`);

function LoadingState() {
  return (
    <div className="mt-4 animate-pulse flex flex-col gap-6" aria-busy="true" aria-live="polite">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {loadingCards.map((card) => (
          <div key={card} className="rounded-2xl border border-slate-200 bg-white/70 shadow-sm p-4 flex flex-col gap-2">
            <div className="h-4 w-24 rounded bg-slate-200" />
            <div className="h-6 w-32 rounded bg-slate-200" />
          </div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white/70 shadow-sm">
        <div className="min-w-[720px] sm:min-w-0">
          <div className="grid grid-cols-4 gap-0 border-b-2 border-gray-200 bg-gray-100/80 px-4 py-3">
            {loadingHeaders.map((header) => (
              <div key={header} className="h-4 w-16 rounded bg-slate-200" />
            ))}
          </div>
          {loadingRows.map((row) => (
            <div key={row} className="grid grid-cols-4 gap-3 border-b border-gray-200 px-4 py-3 last:border-b-0">
              <div className="h-4 w-20 rounded bg-slate-200" />
              <div className="h-4 w-24 rounded bg-slate-200" />
              <div className="h-4 w-24 rounded bg-slate-200" />
              <div className="h-4 w-24 rounded bg-slate-200" />
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">
        <FormattedMessage id="stats.panel.loading" />
      </span>
    </div>
  );
}

export default function StatsPanel() {
  const { data: entries = [], isLoading, error } = useDateHistory();

  const content = () => {
    if (isLoading) {
      return <LoadingState />;
    }
    if (error) {
      return (
        <div className="mt-4 text-sm text-red-700">
          <FormattedMessage
            id="stats.panel.error"
            values={{ message: error.message }}
          />
        </div>
      );
    }
    return (
      <div className="mt-4">
        <StatsPanelView entries={entries} />
      </div>
    );
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 sm:text-3xl">
            <FormattedMessage id="stats.panel.title" />
          </h1>
        </div>
        <div className="flex items-center gap-2 text-xs font-semibold text-slate-600">
          <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400" />
          <FormattedMessage id="stats.panel.monitoring" />
        </div>
      </div>
      {content()}
    </div>
  );
}
